import { useEffect } from 'react';

/**
 * MobileInputZoomFix - Prevents iOS auto-zoom on input focus
 * while keeping original font sizes intact
 */
const MobileInputZoomFix = () => {
  useEffect(() => {
    // Only run on mobile devices
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    // Store original viewport content
    const originalViewport = viewport.getAttribute('content');
    const noZoomViewport = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';

    // Prevent zoom when focusing on input
    const handleFocus = () => {
      viewport.setAttribute('content', noZoomViewport);
    };

    // Restore zoom capability when blurring input
    const handleBlur = () => {
      viewport.setAttribute('content', originalViewport);
    };

    // Add listeners to all inputs
    const inputs = document.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      input.addEventListener('focus', handleFocus, false);
      input.addEventListener('blur', handleBlur, false);
    });

    // Use MutationObserver to handle dynamically added inputs
    const observer = new MutationObserver(() => {
      const newInputs = document.querySelectorAll('input, select, textarea');
      newInputs.forEach(input => {
        if (!input.hasAttribute('data-zoom-fix')) {
          input.setAttribute('data-zoom-fix', 'true');
          input.addEventListener('focus', handleFocus, false);
          input.addEventListener('blur', handleBlur, false);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup
    return () => {
      inputs.forEach(input => {
        input.removeEventListener('focus', handleFocus);
        input.removeEventListener('blur', handleBlur);
      });
      observer.disconnect();
      viewport.setAttribute('content', originalViewport);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default MobileInputZoomFix;
